import styled, {ThemeProps} from 'styled-components';

import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';
import Image from '../../../common/Image/Image';

export const Rating = styled.span(
  (props: Assign<ThemeProps<Theme>, {rating: number}>) => `
  color: ${props.theme.colors.goWhite.base};
  background: ${getRatingsColor(props.rating)};
  border-radius: 2px;
  padding: ${props.theme.spacing.custom(3)} ${props.theme.spacing.small};
  display: flex;
  align-items:center;
  width: fit-content;
  margin: 0 auto;
`,
);

export const tripadvisorImageStyles = styled(Image)`
  max-width: 3rem;
  padding-right: 0.4rem;
`;
